
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CAktLabel"
})
export default class CAktLabel extends Vue {}
